function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Scrollspy from 'react-scrollspy';
import classnames from 'classnames';
import "./QuickLinks.css";

var QuickLinks = /*#__PURE__*/function (_Component) {
  _inheritsLoose(QuickLinks, _Component);

  function QuickLinks(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleClick = function (link) {
      _this.setState({
        activeLink: link
      });

      window.location = link.href;
    };

    _this.handleUpdate = function (elm) {
      if (!elm || !elm.id) {
        return false;
      }

      var link = _this.linkList[elm.id];

      _this.setState({
        activeLink: link
      });

      return true;
    };

    _this.renderLink = function (link, i) {
      var activeLink = _this.state.activeLink;
      var isActive = activeLink === link;
      var depthClass = typeof link.depth === 'number' ? "QuickLinks__Link--depth-" + link.depth : '';
      var classes = classnames('QuickLinks__Link', {
        'QuickLinks__Link--active': isActive
      }, {
        'QuickLinks__Link--disabled': link.disabled
      }, depthClass);
      return /*#__PURE__*/React.createElement("li", {
        key: i,
        className: classes
      }, /*#__PURE__*/React.createElement("a", {
        href: link.href,
        onClick: function onClick() {
          return _this.handleClick(link);
        }
      }, /*#__PURE__*/React.createElement("span", null, link.label)));
    };

    _this.state = {
      activeLink: null
    };
    return _this;
  }

  var _proto = QuickLinks.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.links !== this.props.links) {
      var key = this.scrollSpyItems[0];
      var link = this.linkList[key]; // eslint-disable-next-line react/no-did-update-set-state

      this.setState({
        activeLink: link
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var links = this.props.links;

    if (!links.length) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "QuickLinks"
    }, /*#__PURE__*/React.createElement(Scrollspy, {
      items: this.scrollSpyItems,
      onUpdate: this.handleUpdate
    }, links.map(function (link, i) {
      return _this2.renderLink(link, i);
    })));
  };

  _createClass(QuickLinks, [{
    key: "linkList",
    get: function get() {
      var _this3 = this;

      var linkList = {};
      this.props.links.map(function (item) {
        // set default
        if (typeof item.depth !== 'number') {
          item.depth = 2;
        }

        if (item.depth < 4) {
          // remove the #;
          if (_this3.props.type === 'design' && item.depth === 1) {
            // don't include the top-level H1 on design docs
            return;
          }

          var key = item.href.substring(1);
          linkList[key] = item;
          item.id = key;
        }
      });
      return linkList;
    }
  }, {
    key: "scrollSpyItems",
    get: function get() {
      return Object.keys(this.linkList);
    }
  }]);

  return QuickLinks;
}(Component);

QuickLinks.propTypes = {
  /** Array of link objects. They could include the properties: label, href, disabled. Use the node property to pass in a Link component from react-router. */
  links: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    node: PropTypes.node,
    depth: PropTypes.number
  })),
  type: PropTypes.string
};
QuickLinks.defaultProps = {
  links: []
};
export default QuickLinks;
//# sourceMappingURL=QuickLinks.js.map